
(function userDefinition() {
    'use strict';
    angular.module('Entities')
        .service('userService', [
            'restUrlBuilder', 'config', function userService(restUrlBuilder, config) {
                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id, forEdit) {
                    if (angular.isUndefined(forEdit)) {
                        forEdit = true;
                    }

                    return restUrlBuilder.one('users', 'logged')
                                         .get({
                                             params: {
                                                 forEdit: forEdit
                                             }
                                         });
                };

                this.get = function get(nickName, name, lastName, organizationalUnitId, completeName, identifier, mail, page, itemsPerPage) {
                    var params = { NickName: nickName, FirstName: name, LastName: lastName, OrganizationalUnitId: organizationalUnitId, FullName: completeName, Identifier: identifier, Mail: mail, Page: page, ItemPerPage: itemsPerPage};

                    return restUrlBuilder.all('users')
                        .get({ params: params });

                };

                this.modify = function userModify(user, profile) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.Url = config.appUrl('');

                    return restUrlBuilder.one('users', 'logged')
                                         .put(user, { params: { profile: profile || false } });
                };

                this.getAllForUser = function (name) {
                    var params = { name: name };

                    return restUrlBuilder.all('users/GetAllForUser')
                        .get({ params: params });
                }
            }
        ]);
})();